/* CE Signup Popup — confirmation modal shown AFTER a newsletter signup.
   The popup markup lives in sections/ce-signup-popup.liquid; this script is loaded
   site-wide from theme.liquid so it always runs and intercepts the signup BEFORE
   any page reload (a reload would land on a near-empty page = the "white background").
   Behaves like the geo popup: a plain modal over the current page. */
(function () {
  'use strict';

  function init() {
    var el = document.getElementById('ce-pop');
    if (!el || el.dataset.disabled === 'true') {
      // Still intercept signups even if the popup markup isn't present, to avoid surprises.
    }
    var lock = document.documentElement;

    function open() {
      if (!el) return;
      el.hidden = false; el.classList.add('is-open'); lock.style.overflow = 'hidden';
    }
    function close() {
      if (!el) return;
      el.classList.remove('is-open'); lock.style.overflow = '';
      setTimeout(function () { el.hidden = true; }, 300);
    }

    if (el) {
      el.querySelectorAll('[data-pop-close]').forEach(function (b) { b.addEventListener('click', close); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && el.classList.contains('is-open')) close(); });
      var copy = el.querySelector('[data-pop-copy]');
      if (copy) copy.addEventListener('click', function () {
        var t = copy.getAttribute('data-code') || '';
        if (navigator.clipboard) { navigator.clipboard.writeText(t); }
        copy.textContent = copy.getAttribute('data-copied') || 'Copied';
      });
    }

    function isNewsletterForm(form) {
      var action = form.getAttribute('action') || '';
      return action.indexOf('/contact') > -1
        && form.querySelector('[name="contact[email]"], input[type="email"]')
        && !form.querySelector('[name="contact[body]"]')
        && !form.classList.contains('ce-pop-detect');
    }
    function handleSignup(e) {
      var form = e.target && e.target.closest ? e.target.closest('form') : null;
      if (!form || !isNewsletterForm(form)) return;
      var emailEl = form.querySelector('[name="contact[email]"], input[type="email"]');
      if (!emailEl || !emailEl.value || (emailEl.checkValidity && !emailEl.checkValidity())) return;
      e.preventDefault();
      e.stopPropagation();
      fetch(form.getAttribute('action') || '/contact', { method: 'POST', body: new FormData(form), headers: { 'Accept': 'text/html' } })
        .then(function () { open(); })
        .catch(function () { open(); });
    }
    function bindForms() {
      document.querySelectorAll('form[action*="/contact"]').forEach(function (f) {
        if (!f.__cePopBound) { f.__cePopBound = true; f.addEventListener('submit', handleSignup, true); }
      });
    }
    bindForms();
    try { new MutationObserver(bindForms).observe(document.documentElement, { childList: true, subtree: true }); } catch (err) {}
    document.addEventListener('submit', handleSignup, true); // backup

    // If a full-reload signup still happened, show the confirmation on the reloaded page.
    if (document.getElementById('ce-pop-posted')) open();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
